import axios from 'axios'

import WatchJS from '../services/WatchJs.js'

let mutations = {
    set_go_services(state, data) {
        state.go_services = data
    },

    set_go_services_id(state, sId) {
        if (!sId || (sId && sId !== state.go_services_id)) {
            if (sId) state.go_services_id = sId
            state.go_commands = []
            state.go_commands_id = 0
            axios
                .post('/command/get/' + state.go_services_id)
                .then((response) => {
                    if (response.data.status === 1) {
                        state.go_commands = response.data.data
                    }
                })
        }
    },
    set_go_commands_id(state, cId) {
        state.go_commands_id = cId
    },
    update_go_services(state, data) {
        for (var i = state.go_services.length - 1; i >= 0; i--) {
            if (state.go_services[i]['service_id'] === parseInt(data[0])) {
                state.go_services[i]['service_name'] = data[1]
                break
            }
        }
    },
    delete_go_services(state, id) {
        for (var i = state.go_services.length - 1; i >= 0; i--) {
            if (state.go_services[i]['service_id'] === parseInt(id)) {
                state.go_services.splice(i, 1)
                state.go_services_id = 0
                break
            }
        }
    },
    add_go_services(state, service) {
        state.go_services.push(service)
    },
    update_go_commands(state, data) {
        for (var i = state.go_commands.length - 1; i >= 0; i--) {
            if (state.go_commands[i]['command_id'] === parseInt(data[0])) {
                state.go_commands[i]['command_name'] = data[1]
                break
            }
        }
    },
    delete_go_commands(state, id) {
        for (var i = state.go_commands.length - 1; i >= 0; i--) {
            if (state.go_commands[i]['command_id'] === parseInt(id)) {
                state.go_commands.splice(i, 1)
                state.go_commands_id = 0
                break
            }
        }
    },
    add_go_commands(state, command) {
        state.go_commands.push(command)
    },
    set_go_variables(state, variables) {
        state.go_variables_id = 0
        state.go_variables = variables
    },
    update_go_variables(state, data) {
        for (var i = state.go_variables.length - 1; i >= 0; i--) {
            if (state.go_variables[i]['var_id'] === parseInt(data[0])) {
                state.go_variables[i]['var_name'] = data[1]
                break
            }
        }
    },
    delete_go_variables(state, id) {
        for (var i = state.go_variables.length - 1; i >= 0; i--) {
            if (parseInt(state.go_variables[i]['var_id']) === parseInt(id)) {
                state.go_variables.splice(i, 1)
                state.go_variables_id = 0
                break
            }
        }
    },
    add_go_variables(state, variable) {
        state.go_variables.push(variable)
    },
    set_acl(state, data) {
        state.user = Object.assign(state.user, data)
    },
    add_breadcrumb_history(state, data) {
        let key = '' + Object.keys(data)[0]
        if (!state.breadcrumb_history.hasOwnProperty(key)) {
            state.breadcrumb_history[key] = data[key]
        } else {
            state.breadcrumb_history[key] = Object.assign(state.breadcrumb_history[key], data[key])
        }
    },
    update_breadcrumb_history(state, change) {
        if (state.breadcrumb_history.hasOwnProperty(change.mode)) {
            let ids = Object.keys(state.breadcrumb_history[change.mode])
            for (let i = ids.length - 1; i >= 0; i--) {
                if (parseInt('' + ids[i]) === parseInt(change.id)) {
                    state.breadcrumb_history[change.mode][ids[i]].meta.name = change.change_to
                    break
                }
            }
        }
    },
    set_messenger_init(state, status) {
        state.messenger_init = status
    },
    watchDeference(state, record) {
        state.follow.copyData = {}
        state.follow.originalData = record
        WatchJS.watch(
            state.follow.originalData,
            function (prop, action, difference, oldvalue) {
                if (Object.keys(state.follow.originalData).length !== Object.keys(state.follow.copyData).length) {
                    state.follow.copyData = JSON.parse(JSON.stringify(state.follow.originalData))
                }
            },
            5,
            true
        )
    },

    cleanDeference(state) {
        state.follow.copyData = JSON.parse(JSON.stringify(state.follow.originalData))
    },

    resetWather(state) {
        state.follow.originalData = state.follow.copyData = {}
    },

    setSelectedCommandResponse(state, value) {
        state.commandResponse.selected = value
    },

    setResponseData(state, data) {
        state.responseData = data;
    },

    setResponseDataProperty(state, data) {
        for (const key in data) {
            state.responseData[key] = data[key];
        }
        
    }
}
export default mutations
